import { Component } from '@angular/core';
/**
 * Component that loads auxiliary Angular routes.
 * It is mainly used in the screens generated by `UI Studio`.
 *
 * This class should not be modified.
 */
@Component({
  selector: 'app-proxy-route',
  template: '<router-outlet></router-outlet>',
})
export class ProxyRouteComponent {
}
